import {
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  OAuthProvider,
  getAdditionalUserInfo,
} from 'firebase/auth'
import {
  FirebaseAuthResponse,
  FirebaseAuthResponseError,
  FirebaseAuthResponseSuccess,
} from '../types'
import { auth } from './firebaseAuth'

const appleProvider = new OAuthProvider('apple.com')

export const appleAuthRedirect = function () {
  return signInWithRedirect(auth, appleProvider)
}

export function appleAuth(
  bPopup: boolean
): Promise<FirebaseAuthResponse | undefined> {
  return (bPopup
    ? signInWithPopup(auth, appleProvider)
    : getRedirectResult(auth)
  )
    .then((result) => {
      if (!result) return
      const credential = OAuthProvider.credentialFromResult(result)
      if (!credential) return
      const user = getAdditionalUserInfo(result)
      if (!user) return

      // user =
      //   {
      //     "isNewUser": true,
      //     "providerId": "apple.com",
      //     "profile": {
      //         "at_hash": "jZ7U9kRu8hF2wnD2By295A",
      //         "aud": "auth.mili.live",
      //         "auth_time": 1678222451,
      //         "exp": 1678308857,
      //         "iat": 1678222457,
      //         "iss": "https://appleid.apple.com",
      //         "sub": "000627.b8521894e54d40e5b76a31f0eb21a0ae.1742",
      //         "email": "zmqhqvfkjh@privaterelay.appleid.com",
      //         "email_verified": "true",
      //         "is_private_email": "true",
      //         "nonce_supported": true
      //     }
      // }
      const id = btoa(user.profile.email as string)

      const payload: FirebaseAuthResponseSuccess = {
        type: 'success',
        id,
        email: String(user?.profile?.email || ''),
        firstName: '',
        lastName: '',
        avatar: '',
      }
      return payload
    })
    .catch((error) => {
      const response: FirebaseAuthResponseError = {
        type: 'error',
        code: error.code,
        message: error.message,
        email: error.email,
      }
      return response
    })
}
